// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed6b30b5","455":"338fd508"}[chunkId] + ".chunk.js";
};